import { Box, IconButton, Stack, Typography } from "@mui/material";
import EllipseIcon from "assets/svg/EllipseIcon";
import QueryIcon from "assets/svg/QueryIcon";
import TransactionIcon from "assets/svg/TransactionIcon";
import { commonStyle } from "pages/Dashboard/common.styles";
import {
  DataGrid,
  GridRenderCellParams,
  GridRowParams,
  useGridApiRef,
} from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reduxStore/store";
import { useEffect } from "react";
import { FETCH_TRANSACTIONS } from "reduxStore/actions/authActionType";
import { transactionColumn } from "pages/Dashboard/TransactionsPage/dataGridDef";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import theme from "themes/Theme";
import NoRowsTableDataOverlay from "components/NoRowsTableDataOverlay/NoRowsTableDataOverlay";

const RecentTransactionCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiRef = useGridApiRef();
  const { transactions, loading } = useSelector(
    (state: RootState) => state.transaction
  );

  useEffect(() => {
    dispatch({ type: FETCH_TRANSACTIONS, payload: {} });
  }, []);

  const updatedColumns = transactionColumn.map((col) =>
    col.field === "id"
      ? {
          ...col,
          renderCell: (params: GridRenderCellParams) => {
            const { id } = params;
            const rowIndex = params.api.getRowIndexRelativeToVisibleRows(id);
            const page = apiRef.current.state.pagination.paginationModel.page;
            const pageSize =
              apiRef.current.state.pagination.paginationModel.pageSize;
            return rowIndex + 1 + page * pageSize;
          },
        }
      : col
  );

  const handleRowClick = (params: GridRowParams) => {
    navigate(`/dashboard/transactions/${params.row.transactionId}`);
  };

  return (
    <Box sx={commonStyle.cardStyle}>
      <Box sx={commonStyle.flexSpaceBetween}>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <TransactionIcon />
          <Typography sx={commonStyle.cardTitleText}>
            Recent Transactions
          </Typography>
        </Stack>
        <IconButton onClick={() => navigate("/dashboard/transactions")}>
          <ChevronRightIcon sx={{ color: theme.palette.text.primary }} />
        </IconButton>
      </Box>
      <DataGrid
        apiRef={apiRef}
        rows={transactions?.data?.transactions || []}
        columns={updatedColumns}
        getRowId={(row) => row.transactionId}
        onRowClick={handleRowClick}
        slots={{
          noRowsOverlay: () => (
            <NoRowsTableDataOverlay title={"No transactions found"} />
          ),
        }}
        sx={{
          border: 0,
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
          },
        }}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        hideFooter
        hideFooterPagination
        disableRowSelectionOnClick
      />
    </Box>
  );
};
export default RecentTransactionCard;
